const reportsTitleBarMenu = {
  contentType: "reports",
 menuItems: [
  //   {
  //     _menuId: "reportsTitleBarMenu_1",
  //     type: "TITLEBAR_MENU_ITEM",
  //     label: "View PDF",
  //     action: "pdf",
  //   },
  //   {
  //     _menuId: "reportsTitleBarMenu_2",
  //     type: "TITLEBAR_MENU_ITEM",
  //     label: "Save Query...",
  //     action: "saveQuery",
  //   },
  ],
  toolbar: [
  //   {
  //     _iconId: "reportsTitleBarToolbar_1",
  //     type: "TITLEBAR_TOOLBAR_ICON",
  //     icon: "cart-arrow-down",
  //     action: "saveQuery",
  //     label: "Save Query",
  //   },
  //   {
  //     _iconId: "reportsTitleBarToolbar_1.separator",
  //     type: "TITLEBAR_TOOLBAR_SEPARATOR",
  //   },
  //   {
  //     _iconId: "reportsTitleBarToolbar_2",
  //     type: "TITLEBAR_TOOLBAR_ICON",
  //     icon: "file-pdf",
  //     action: "pdf",
  //     label: "PDF",
  //   },
  ],
};

export default reportsTitleBarMenu;
